import { render, staticRenderFns } from "./CollapsibleH3.vue?vue&type=template&id=3634e4e6&scoped=true&"
import script from "./CollapsibleH3.vue?vue&type=script&lang=js&"
export * from "./CollapsibleH3.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleH3.vue?vue&type=style&index=0&id=3634e4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3634e4e6",
  null
  
)

export default component.exports